module.exports = __webpack_public_path__ + "img/esportslivescore.d1109128.png";